import { SprievodnyDokumentListChangeOrderApi } from 'evidencna-aplikacia-frontend-ts-axios';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import Uuid from '../../../model/Uuid';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import SprievodnyDokument from '../../../model/legislativnyMaterial/SprievodnyDokument';

const client = new SprievodnyDokumentListChangeOrderApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const changeOrder = async (
  legMaterialUuid: Uuid,
  stadiumUuid: Uuid,
  sprievodnyDokumentList: Array<SprievodnyDokument>,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client
    .changeOrderSprievodnyDokumentList(
      legMaterialUuid,
      stadiumUuid,
      sprievodnyDokumentList.map(dokument => dokument.uuid),
      headers,
    );
  return {
    responseCode: status,
  };
};
